import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import ScorecardFiltersViewModel from "../../Viewmodels/ScorecardFiltersViewModel";
import ClearIcon from '@mui/icons-material/Clear';
import IconButton from "@mui/material/IconButton";

interface IScorecardNameFiltersDialogProps {
    open: boolean;
    setOpen: (isOpen: boolean) => void;
    currentName: string;
    changeFilter: (filterName: keyof ScorecardFiltersViewModel, newValue: any) => void;
}

export default function ScorecardNameFiltersDialog({ open, setOpen, currentName, changeFilter }: IScorecardNameFiltersDialogProps) {
    const [name, setName] = useState(currentName);

    const confirm = () => {
        changeFilter('name', name);
        setOpen(false);
    }

    return (
        <Dialog onClose={() => setOpen(false)} open={open} fullWidth maxWidth="sm" >
            <DialogTitle>Name Filters</DialogTitle>
            <DialogContent>
                <Grid container height="100%">
                    <Grid container size={12}>
                        <Grid size={12} >
                            <TextField
                                value={name}
                                onChange={((e) => { setName(e.target.value) })}
                                fullWidth
                                autoComplete='off'
                                InputProps={{
                                    endAdornment: (
                                        <IconButton
                                            onClick={() => setName('')}
                                            sx={{ visibility: name !== '' ? 'visible' : 'hidden' }}>
                                            <ClearIcon />
                                        </IconButton>)
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpen(false)}>
                    Cancel
                </Button>
                <Button onClick={confirm}>
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    )
}